import { Sunrise, Sun, Moon, Coffee } from "lucide-react";

export const SHIFT_TYPES = ["morning", "afternoon", "night", "off"];

export const SHIFT_META = {
  morning: { color: "#F59E0B", icon: Sunrise },
  afternoon: { color: "#38BDF8", icon: Sun },
  night: { color: "#818CF8", icon: Moon },
  off: { color: "#6B7280", icon: Coffee },
};

export function monthKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(monthStr, lang = "en") {
  const [y, m] = monthStr.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString(lang, { month: "long", year: "numeric" });
}
